import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_horario/get/all`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_horario/get/list`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_horario/${id}`);
  return response;
};

const createOrUpdate = async (data) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo_horario`, data);
  return response;
}

const update = async (id, data) => {
  const response = await put(`${process.env.REACT_APP_SERVER}odoo_horario/${id}`, data);
  return response;
}

export {getAll, getList, getById, createOrUpdate, update};